import Builder from './class-builder';

class AdjustableAluminumBuilder extends Builder {

  /*
  * Render path for desktop
  */
  getRenderPathDesktop() {
    return this.renderDomain + 'adjustable-aluminum/desktop/';
  }

  /*
  * Render path for mobile
  */
  getRenderPathMobile() {
    return this.renderDomain + 'adjustable-aluminum/mobile/';
  }

  /*
  * Create image SKU
  */
  getRenderImage() {
    return 'ST3609' + this.getTreadProfileImage(this.selection_data.tread_profile) + this.getTreadCoveringImage(this.selection_data.tread_covering) + this.getBalusterTypeImage(this.selection_data.baluster_type) + this.getHandrailImage(this.selection_data.handrail);
  }

  /*
  * Match tread profile SKU
  */
  getTreadProfileImage(tread_profile) {
    switch (tread_profile) {
      case 'S':
      case 'L':
      case 'R':
        return tread_profile;
      case 'C':
        return 'S';
      default:
        return 'S';
    }
  }

  /*
  * Match tread covering SKU
  */
  getTreadCoveringImage(tread_covering) {
    switch (tread_covering) {
      case 'B':
      case 'D':
        return tread_covering;
      default:
        return 'B';
    }
  }

  /*
  * Match tread covering SKU
  */
  getBalusterTypeImage(baluster_type) {
    switch (baluster_type) {
      case 'A':
      case 'B':
        return baluster_type;
      default:
        return 'A';
    }
  }

  /*
  * Match handrail SKU
  */
  getHandrailImage(handrail) {
    switch (handrail) {
      case 'A':
      case 'V':
        return handrail;
      default:
        return 'A';
    }
  }

  /*
  * Create sku from object
  * The order of the sku matches the spreadsheet from Mary
  */
  setSku() {
    this.sku = this.selection_data.product_line + this.selection_data.width + this.selection_data.height + this.selection_data.tread_profile + this.selection_data.tread_covering + this.selection_data.baluster_type + this.selection_data.handrail;
  }

  /*
  * Create object from sku
  * The order of the sku matches the spreadsheet from Mary
  */
  getSkuObject(sku) {
    var product_line,
        width,
        height,
        tread_profile,
        tread_covering,
        baluster_type,
        handrail,
        selection_data = {};

    if (sku) {
      product_line = sku.substring(0, 2);
      width = sku.substring(2, 4);
      height = sku.substring(4, 6);
      tread_profile = sku.substring(6, 7);
      tread_covering = sku.substring(7, 8);
      baluster_type = sku.substring(8, 9);
      handrail = sku.substring(9, 10);


      selection_data = {
        'product_line' : product_line,
        'width' : width,
        'height' : height,
        'tread_profile' : tread_profile,
        'tread_covering' : tread_covering,
        'baluster_type' : baluster_type,
        'handrail' : handrail,
      }
    }

    this.selection_data = selection_data;
    return selection_data;
  }

}

export default AdjustableAluminumBuilder;
